import validate from "/opt/build/repo/node_modules/nuxt/dist/pages/runtime/validate.js";
import maintenance_45global from "/opt/build/repo/middleware/maintenance.global.ts";
export const globalMiddleware = [
  validate,
  maintenance_45global
]
export const namedMiddleware = {
  session: () => import("/opt/build/repo/middleware/session.ts")
}